module.exports = __webpack_public_path__ + "static/media/more-vert.507d4365.svg";